const html = document.querySelector("html");
const body = document.querySelector(".body");


//====== Registerd ScrollTrigger Plugin ==========
gsap.registerPlugin(ScrollTrigger);

function hideLoader(){
  tl.to(".loader-upper",{
      y:"-100%",
      duration:0.8,
      ease: "sine.inOut",
  })
  // tl.to(".loader-inner",{
  //     x:"100%",
  //     duration:0.8,
  //     ease: "sine.inOut",
  // }, "-=0.15")
}

//========= LENIS START =========
const lenis = new Lenis({
  duration: 1,
  smooth:true,
  infinite: false,
  syncTouch:false, // mimic touch device scroll while allowing scroll sync (can be unstable on iOS<16)
  smoothTouch: false,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});

function raf(time){
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);
//========= LENIS END =========

//========= SCROLL & NAVBAR TOGGLE START =========
const header = document.querySelector(".header");

let prevScrollPos = 0;
const scrollThreshold = 10;  // Prevents accidental small scroll triggers
const mobileMenu = document.querySelector(".aside-mobile");
const mobileMenuBody = mobileMenu.querySelector(".mobile-menu__body")

function checkScroll() {
  let scrollTop = lenis.scroll || document.documentElement.scrollTop;
  if (scrollTop > scrollThreshold) {
    header.classList.add("sticky");
    mobileMenuBody.classList.add("scrollTop");
  } else if (scrollTop === 0) {
    header.classList.remove("sticky");
    mobileMenuBody.classList.remove("scrollTop");
  }
  prevScrollPos = Math.max(0, scrollTop);
}

//========= SCROLL & NAVBAR TOGGLE END =========

//======= LENIS SCROLL CONTROL =========
let isOpened = false;
function stopLenisScroll(){
  // isOpened = !isOpened;
  // isOpened ?  lenis.stop() : lenis.start() 
  lenis.stop();
  isOpened = true;
}

function startLenisScroll(){
  lenis.start();
  isOpened = false;
}

//======= ACTIVE NAVIGATION LINK START =========
const windowPathname = window.location.pathname;
const navLinks = document.querySelectorAll(".navbar__link");

navLinks.forEach(link =>{
 const navLinkPathname = new URL(link.href, window.location.origin).pathname;
 const isActiveLink = windowPathname === navLinkPathname || (windowPathname === "/index.html" && navLinkPathname === "/")
  link.classList.toggle("active", isActiveLink);
});
//======= ACTIVE NAVIGATION LINK END =========


//======= BANNER CONTENT ANIMATION START =========
function bannerContentsAnimation(){
  const tl = gsap.timeline();
  // Header Animation Start
  tl.from([".header__logo", ".header-btn"], {
    opacity: 0,
    y: 50,
    delay: 0.2,
    duration: 1,
    stagger:0.1,
    ease: Expo.easeInOut,
  });
  tl.from([".navbar__link", "#hamburger-btn"], {
      opacity:0,
      y:40,
      duration:0.8,
      stagger:0.1,
      delay:-1,
      ease:"power4.out",
    }
  );
  // Header Animation End

  tl.from(".hero-title", {
    opacity: 0,
    duration: 1,
    // y: 50,
    delay: -1.15,
    stagger:0.1,
    // ease: "power4.in",
  });
  const heroSubTitle = document.querySelector(".hero-subTitle");
  heroSubTitle && tl.from(heroSubTitle, {
    opacity: 0,
    duration: 1,
    y: 50,
    delay: -1.25,
    stagger:0.1,
    ease: "power4.out",
  });
  
  const heroBtns = document.querySelectorAll(".banner-btn");
  heroBtns && heroBtns.forEach((heroBtn)=>{
    tl.from(heroBtn, {
      opacity: 0,
      duration: 1,
      y: 50,
      delay: -1,
      stagger:0.1,
      ease: "power4.out",
    });
  })

  tl.fromTo(".banner-counter-wrapper",
    {
      opacity:0,
      scale:0,
      transformOrigin:"left",
    },{
      opacity:1,
      scale:1,
      duration:1,
      delay:-1.65,
      stagger:0.15,
      ease:"power4.inOut",
    }
  )

  const bannerImage = document.querySelectorAll(".banner-img");
  bannerImage && tl.from(bannerImage, {
    opacity: 0,
    // y: 30,
    duration: 1,
    delay: -2.10,
    stagger:0.1,
    ease:"power4.in",
  });
  

  tl.from(".form__group",{
    opacity:0,
    y:30,
    duration:0.8,
    delay:-2,
    stagger:0.1,
    ease:"power4.in"
  })

  tl.from(".team-img", {
    opacity:0,
    y:50,
    duration:1,
    stagger:0.1,
    delay:-2,
    ease:"power4.in"
  })
  tl.from(".socials__list li",{
    opacity:0,
    y:30,
    delay:-1.65,
    duration:1,
    stagger:0.2,
    ease:"power4.inOut"
  })
}
//======= BANNER CONTENT ANIMATION END =========

//====== TOGGLE MOBILE SUBMENU START ==========
const mobileMenuLinks = document.querySelectorAll(".mobile-menu__item");
const mobileMenuLinksArr = Array.from(mobileMenuLinks);
const hamburgerBtn = document.getElementById("menuToggle");
// const mobileMenu = document.querySelector(".aside-mobile");

const tl = gsap.timeline();
hamburgerBtn.addEventListener('click', function(){
  this.classList.toggle("active");
  mobileMenu.classList.toggle("show");
  mobileMenuLinksArr.forEach((mobileLink)=>{
      gsap.fromTo(mobileLink,
        {
          opacity:0,
          y:50,
        },{
          opacity:1,
          y:0,
          duration:1,
          stagger:1,
          ease:"power4.inOut"
        }
      );
  });

  tl.fromTo(".socials__item", 
    {
      opacity:0,
      y:40,
    },{
      opacity:1,
      y:0,
      stagger:0.2,
      delay:-0.1,
      duration:1,
      ease:"power4.inOut",
    }
  )

  !isOpened ? stopLenisScroll() : startLenisScroll();
});
//====== TOGGLE MOBILE SUBMENU END ==========


// ===== Lazy loading background images start =====
// let windowSize = 
let lazyBackgrounds = [].slice.call(document.querySelectorAll("[data-bg]"));

if("IntersectionObserver" in window){
  const lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if(entry.isIntersecting){
        let lazyBackground = entry.target;
        let imgUrl = lazyBackground.getAttribute("data-bg");
        if(entry.target.classList.contains("gradient-overlay")){
          let linearGredient = "linear-gradient(to bottom, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 1))";
          lazyBackground.style.backgroundImage = `${linearGredient}, url("${imgUrl}")`;
        }else{
          lazyBackground.style.backgroundImage = `url("${imgUrl}")`;
        }
        lazyBackground.classList.remove("lazy");
        lazyBackgroundObserver.unobserve(lazyBackground);
      }
    });
  });

  lazyBackgrounds.forEach((lazyBackground) =>{
    lazyBackgroundObserver.observe(lazyBackground);
  });
}
// ===== Lazy loading background images End =====

//======== ACCORDION TOGGLE START ========
let content;
function toggleAccordion(element){ 
  element.classList.toggle("is-open");
  content = element.nextElementSibling;
  if(content){
    const isOpening = content.style.maxHeight;
    content.style.maxHeight = isOpening ? null : `${content.scrollHeight}px`;
    gsap.fromTo(content.children, 
      { opacity: 0, y:50 },
      { opacity: 1, y:0, duration:0.75, stagger:0.2, ease:"power4.out"}
    );
  }
}

const accordionBtns = document.querySelectorAll(".accordion-title");
accordionBtns && accordionBtns.forEach((accordion) => {
  accordion.addEventListener("click",function (e){
    e.stopPropagation();
    toggleAccordion(accordion);
    accordionBtns.forEach(otherAccordion => {
      if(otherAccordion !== accordion) {
        otherAccordion.classList.remove("is-open");
        otherAccordion.nextElementSibling.style.maxHeight = null;
      }
    });
  });
});

const mobileSubmenus = document.querySelectorAll(".mobileSubmenu");
mobileSubmenus.forEach((mobileSubmenu)=>{
  mobileSubmenu.addEventListener("click", function(){
    toggleAccordion(this)
  });
});
//======== ACCORDION TOGGLE END ========

// //======= COUNTER START  ===========
// function visible($el) {
//   let $w = jQuery(window),
//     viewTop = $w.scrollTop(),
//     viewBottom = viewTop + $w.height(),
//     elTop = $el.offset().top,
//     elBottom = elTop + $el.height();
//     compareTop = $el === true ? elBottom : elTop,
//     compareBottom = $el === true ? elTop : elBottom;

//   return (
//     compareBottom <= viewBottom && compareTop >= viewTop && $el.is(":visible")
//   );
// }


// function updateCounter(){
//   ScrollTrigger.create({
//     trigger: "#stats-section",
//     start: "top 80%",
//     once: true,
//     onEnter: () => {
//       if ($("#stats-section").hasClass("animated")) return; // already run
    
//       $("#stats-section").addClass("animated"); // mark it as run
    
//       document.querySelectorAll(".counter-value").forEach((el) => {
//         const target = parseFloat(el.dataset.target);
//         const formatType = el.dataset.format;
    
//         gsap.fromTo(el,
//           { innerText: 0 },
//           {
//             innerText: target,
//             duration: 2,
//             ease: "power1.out",
//             snap: { innerText: 1 },
//             onUpdate: function () {
//               const value = Math.trunc(el.innerText);
//               if (formatType === "abbreviated") {
//                 el.innerText = value;
//               } else {
//                 el.innerText = value.toLocaleString("en-US");
//               }
//             }
//           }
//         );
//       });
//     }
    
//   });
// }
//======= COUNTER END ==========


//======= FLOATING INPUT LABLE START ======
document.querySelectorAll(".form__control").forEach((input) => {
  input.addEventListener("focus", () => input.nextElementSibling.classList.add("focused"))
  input.addEventListener("blur", () => input.nextElementSibling.classList.toggle("focused", input.value !== ""));
}); 
//======= FLOATING INPUT LABLE END ======

const swiperServices = new Swiper(".swiper-services",{
  spaceBetween: 10,
  slidesPerView: 1.15,
  grabCursor: true,
  navigation:{
    nextEl:"#swiper-next-services",
    prevEl:"#swiper-prev-services",
  },
  breakpoints:{
    576:{
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768:{
      slidesPerView:3,
      spaceBetween: 20,         
    },
  }
});

const swiperGifts = new Swiper(".swiper-gifts-slider",{
  spaceBetween: 10,
  slidesPerView: 1,
  grabCursor: true,
  navigation:{
    prevEl:"#gift-swiper-prev",
    nextEl:"#gift-swiper-next",
  },
  breakpoints:{
    576:{
      slidesPerView: 2,
      spaceBetween: 16,
    },
    992:{
      slidesPerView:3,
      spaceBetween: 20,         
    },
    992:{
      slidesPerView:3
    }
  }
});

const swiper = new Swiper(".mySwiper-testimonial", {
  // effect: "fade", // Fades other cards
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on: {
    init: function (swiperInstance) {
      updateSlideNumber(swiperInstance);
    },
    slideChange: function (swiperInstance) {
      updateSlideNumber(swiperInstance);
    }
  }
});

function updateSlideNumber(swiperInstance) {
  const total = swiperInstance.slides.length - swiperInstance.loopedSlides * 2;
  const current = (swiperInstance.realIndex + 1).toString().padStart(2, '0');
  const totalFormatted = total.toString().padStart(2, '0');

  document.querySelectorAll('.slide-number').forEach(el => {
    el.textContent = `${current}/${totalFormatted}`;
  });
}


// ==== Swiper Slide Cards Horo Start ======
const swiperCards = new Swiper(".swiper-cards", {
  effect: "fade", // Fades other cards
  loop: false,
  allowTouchMove: false, // disable swipe, only allow bullet click
  pagination: {
    el: ".swiper-pagination--swiper-cards",
    clickable: true,
  },
  on: {
    slideChangeTransitionEnd: function () {
      let slides = document.querySelectorAll('.swiper-slide-cards');
      slides.forEach((slide, index) => {
        slide.style.zIndex = (index === this.activeIndex) ? 10 : index;
      });
    }
  }
});


// ======= Modal Script Start =======
const modal = document.getElementById("memberModal");
const closeModalBtn = document.getElementById("closeModalBtn");
const teamMembers = document.querySelectorAll(".readBioBtn");

teamMembers.forEach(member =>{
  member.addEventListener("click", (e)=>{
    const modalFigure = modal.querySelector(".modal-figure");
    const modalName = modal.querySelector("#modalName");
    const modalTitle = modal.querySelector("#modalTitle");
    const modalDesc = modal.querySelector("#modalDescription");

    const thumbImageUrl = member.dataset.image;
    if(thumbImageUrl){
      modalFigure.style.display = "block";
      const modalThumbImage = modalFigure.querySelector("img");
      modalThumbImage.src = thumbImageUrl;
      modalThumbImage.alt = name;
    }else{
      modalFigure.style.display = "none";
    }

    const name = member.dataset.name;
    const title = member.dataset.title;
    const desc = member.dataset.description;

    modalName.textContent = name;
    modalTitle.textContent = title;

    modalDesc.innerHTML = "";
    desc.split("\n").forEach((paragraph) =>{
      const trimmed = paragraph.trim();
      if(trimmed){
        const p = document.createElement("p");
        p.textContent = trimmed;
        modalDesc.appendChild(p);
      }
    });

    modal.classList.add("show");

    gsap.fromTo(".modal-content", 
      { y:50, opacity:0},
      { y:0, opacity:1, duration:0.5, ease:"power3.out"},
    );
    stopLenisScroll();
  });
});

// Close The Modal
const closeModal =()=>{
  gsap.to(".modal-content", {
    y:50, opacity:0, duration:0.5, ease:"power3.in",
    onComplete:()=>{
      modal.classList.remove("show");
      startLenisScroll();
    }
  });
}

closeModalBtn && closeModalBtn.addEventListener("click", closeModal);

// Close Modal on background click
modal && modal.addEventListener("click", (e)=>{
  if(e.target === modal) closeModal();
});
// ======= Modal Script End =======


//====== ANIMATION SCRIPT START =========
const textContainers = gsap.utils.toArray(".fade-up");
textContainers.forEach((textContainer, i) => {
  gsap.fromTo(textContainer,
    { opacity: 0, y: 50 },
    { opacity: 1, y: 0, duration: 1, stagger:0.2, ease:"power2.out",
      scrollTrigger:{
        trigger: textContainer,
        toggleActions: "play none none none",
        once: true
      }
    }
  );
});

const fadeIn = gsap.utils.toArray(".fade-in");
fadeIn.forEach((mainContent, i) => {
  const anim = gsap.fromTo(mainContent,
    { opacity: 0 },
    { opacity: 1, duration: 1, ease: "power2.in",
       scrollTrigger:{
        trigger: mainContent,
        // animation: anim,
        // toggleActions: "play",
        toggleActions: "play none none none",
        once: true
      }
    }
  );
});
//====== ANIMATION SCRIPT END =========

const dividers = gsap.utils.toArray(".divider");
dividers.forEach((divider, i)=>{
  const anim = gsap.fromTo(divider,
    { opacity:0, width:"0%", transformOrigin:"left"},
    { opacity:1, width:"100%", duration:1.5, ease:"power4.inOut"}
  )
  ScrollTrigger.create({
    trigger: divider,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1.5,
    // delay:-0.1,
    stagger:0.1,
    ease: "power4.inOut",
  });
})

  
//==== FILTER PORTFOLIO START ========
function filterCards(category){
  const cards = document.querySelectorAll('.filter-projects');
  cards.forEach((card) => {
    let cardCategories = card.dataset.category.split(' ');
    const isVisible = category === "all" || cardCategories.includes(category)
    card.classList.toggle("show", isVisible);
    gsap.fromTo(card,
      {
        opacity:0
      },
      {
        opacity:1,
        duration:0.5,
        stagger:0.1,
        ease:"power2.in",
      }
    );
  });
  updateButtonState(category);
}
  
const tabBtns = document.querySelectorAll(".btn--tab");
if(tabBtns.length){
  tabBtns.forEach((filterBtn) => {
    filterBtn.addEventListener("click", (e)=> filterCards(e.target.dataset.value));
  });
}

//----- Update Button State -----
function updateButtonState(category){
  tabBtns.forEach((tabBtn) => {
    const isActive = tabBtn.getAttribute("data-value") === category;
    tabBtn.classList.toggle("active", isActive);
  });
}
//====== FILTER PORTFOLIO END =============

// ====== Scroll Back To Top Start ======
const backToTopBtn = document.getElementById("backToTop");
function toggleBackToTop(){
  if (window.scrollY > 1600) {
    backToTopBtn.classList.add("show");
    gsap.to(backToTopBtn, { autoAlpha: 1, duration: 0.5 });
  } else {
    backToTopBtn.classList.remove("show");
    gsap.to(backToTopBtn, { autoAlpha: 0, duration: 0.5 });
  }
}

backToTopBtn && backToTopBtn.addEventListener("click", () => {
  lenis.scrollTo(0); // This is the key part: Lenis handles smooth scroll
});


// ==== Scroll back To Top End ====


window.addEventListener("load",()=>{
  hideLoader();
  bannerContentsAnimation();
  tabBtns.length && filterCards('all');
});

// Lenis scroll event
const onLenisScroll =()=>{
  checkScroll();
  // updateCounter();
  toggleBackToTop();
  ScrollTrigger.update();
}

lenis.on('scroll', onLenisScroll);

// Sync Lenis with GSAP
gsap.ticker.add((time)=>{
  lenis.raf(time * 1000);
});

// Disable GSAP lag smoothing for better performance
gsap.ticker.lagSmoothing(0);
